import React, { Component } from "react";
import {
  TextFilter,
  AutoSuggest,
  BooleanField,
  RangeSlider,
  DateTimeRange,
  TimeRange,
  DateRange,
  DateTime,
  Time,
  Date,
  RangeInput,
} from "./FilterTypes";

class FilterRow extends Component {
  render() {
    const { _ } = this.props;
    const Filters = (type) => {
      switch (type) {
        case "Text":
          return <TextFilter {...this.props.Filter} />;
        case "AutoSuggest":
          return <AutoSuggest {...this.props.Filter} />;
        case "Toggle":
        case "Boolean":
          return <BooleanField {...this.props.Filter} />;
        case "NumberRange":
          return <RangeInput {...this.props.Filter} />;
        case "DateTimeRange":
          return <DateTimeRange {...this.props.Filter} _={_} />;
        case "TimeRange":
          return <TimeRange {...this.props.Filter} _={_} />;
        case "DateRange":
          return <DateRange {...this.props.Filter} _={_} />;
        case "DateTime":
          return <DateTime {...this.props.Filter} _={_} />;
        case "Time":
          return <Time {...this.props.Filter} />;
        case "Date":
          return <Date {...this.props.Filter} />;
        default:
          return null;
      }
    };
    return (
      // <Toggle
      //   Heading={
      //     <h4 className="section-heading">{this.props.Filter.FilterName}</h4>
      //   }
      // >
      <div className="filter">{Filters(this.props.Filter.FilterType)}</div>
      // </Toggle>
    );
  }
}

export default FilterRow;
